import { formatDate, formatTime, isValidDate } from "@utils/dates";

export function EventDate({ date }:any) {
    const hasStartDate = isValidDate(date.start_date);
    const hasEndDate = isValidDate(date.end_date);

    const hasDifferentEndDate = (
        isValidDate(date.start_date)
        && isValidDate(date.end_date)
        && (
            date.start_date != date.end_date
            //|| date.start_time != date.end_time
        )
    );

    const hasDifferentEndTime = date.start_time != date.end_time;

    const hasStartTime = date.start_time && !!date.start_time.length;
    const hasEndTime = date.end_time && !!date.end_time.length;

    const hasEndDateOrTime = hasEndDate || hasEndTime;

    return (
        <div>
            {hasStartDate && (
                <span>
                    {formatDate(date.start_date)}
                    {date.start_time && <>{` ${hasDifferentEndTime ? 'from' : 'at'} `}</>}
                    {formatTime(date.start_time)}
                </span>
            )}
            {
                (
                    (hasEndDateOrTime && hasDifferentEndDate)
                    ||
                    (hasEndTime)
                )
                && (<> {hasStartTime ? 'to' : 'until'} </>)
            }
            {hasDifferentEndDate && (<span>{formatDate(date.end_date)}</span>)}
            {hasEndTime && <span> {hasDifferentEndDate ? 'at ' : ''}{formatTime(date.end_time)}</span>}
        </div>
    )
}
